import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Reactions = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.07046 9.24264C6.4103 8.58248 5.90268 7.92112 5.6111 7.39627C5.47915 7.15877 5.40298 6.96967 5.3694 6.83447C5.5046 6.86805 5.6937 6.94422 5.9312 7.07617C6.45605 7.36775 7.11741 7.87537 7.77757 8.53553C8.43773 9.1957 8.94536 9.85706 9.23694 10.3819C9.36888 10.6194 9.44506 10.8085 9.47863 10.9437C9.34343 10.9101 9.15433 10.8339 8.91684 10.702C8.39199 10.4104 7.73063 9.9028 7.07046 9.24264ZM4.37338 6.4738C4.40491 6.32873 4.47175 6.1845 4.59559 6.06066C4.87265 5.7836 5.25179 5.79182 5.51394 5.84258C5.79676 5.89736 6.10653 6.02962 6.41684 6.20201C7.04364 6.55023 7.778 7.12175 8.48468 7.82843C9.19135 8.5351 9.76287 9.26946 10.1111 9.89627C10.2835 10.2066 10.4157 10.5163 10.4705 10.7992C10.5213 11.0613 10.5295 11.4405 10.2524 11.7175C10.1205 11.8495 9.96539 11.9167 9.8108 11.9455L2.36598 15.1336C1.5275 15.4926 0.685416 14.6336 1.06108 13.8024L4.37338 6.4738ZM8.30359 11.5031C7.70595 11.1506 7.02261 10.609 6.36336 9.94975C5.69226 9.27865 5.14304 8.58257 4.79121 7.97737L1.97233 14.2143L8.30359 11.5031Z"
        fill={color}
      />
      <path
        d="M10 1L10.086 1.23238C10.2886 1.77982 10.7202 2.21144 11.2676 2.41401L11.5 2.5L11.2676 2.58599C10.7202 2.78856 10.2886 3.22018 10.086 3.76762L10 4L9.91401 3.76762C9.71144 3.22018 9.27982 2.78856 8.73238 2.58599L8.5 2.5L8.73238 2.41401C9.27982 2.21144 9.71144 1.77982 9.91401 1.23238L10 1Z"
        fill={color}
      />
      <path
        d="M14 6C14.1714 6.46329 14.5367 6.82857 15 7C14.5367 7.17143 14.1714 7.53671 14 8C13.8286 7.53671 13.4633 7.17143 13 7C13.4633 6.82857 13.8286 6.46329 14 6Z"
        fill={color}
      />
      <path
        d="M13.5 3.5L12.8305 4.95277C12.6615 5.31941 12.2887 5.5485 11.8853 5.53356L10.953 5.49901C10.5495 5.48406 10.1767 5.71315 10.0077 6.07979L9.33825 7.53256"
        stroke={color}
        strokeLinecap="round"
      />
      <path
        d="M14.623 9.8636C14.623 9.8636 14.2268 9.18399 13.2269 9.18398C12.2271 9.18398 11.1709 9.8636 11.1709 9.8636"
        stroke={color}
        strokeLinecap="round"
      />
      <path
        d="M6.50016 2.00012C6.50016 2.00012 7.49997 2.50012 7.5 3.50012C7.50003 4.50013 7.00012 5.50012 7.00012 5.50012"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  )
})

export default Reactions
